import CombineApi from './CombineApi';

export const aadhaarDetailsGenerateOtp = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/aadhaar-details-generate-otp',
    body,
    authToken,
  );

export const aadhaarDetailsVerifyOtp = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/aadhaar-details-verify-otp',
    body,
    authToken,
  );

export const validateAadhaar = (body, authToken) =>
  CombineApi.productionPost('apiProduct/aadhaar-validation', body, authToken);

export const verifyAadhaarUANLinkDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/aadhaar-uan-link', body, authToken);

export const validateDrivingLicense = (body, authToken) =>
  CombineApi.productionPost('apiProduct/driving-license', body, authToken);

export const validateVoterId = (body, authToken) =>
  CombineApi.productionPost('apiProduct/verify-voterid', body, authToken);

export const validateRCText = (body, authToken) =>
  CombineApi.productionPost('apiProduct/verify-rc', body, authToken);

export const validatePanLite = (body, authToken) =>
  CombineApi.productionPost('apiProduct/verify-pan-lite', body, authToken);

export const validatePanComprehensive = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/verify-pan-comprehensive',
    body,
    authToken,
  );

export const BankVerification = (body, authToken) =>
  CombineApi.productionPost('apiProduct/bank-verification', body, authToken);

export const BankPennylessVerificationDetails = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/bank-verification-pennyless',
    body,
    authToken,
  );

export const VerifyCorporateDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/coporate-cin', body, authToken);

export const VerifyDINDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/din-verification', body, authToken);

export const VerifyFSSAIDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/fssai-verification', body, authToken);

export const VerifyGSTVerificationAdvance = (body, authToken) =>
  CombineApi.productionPost('apiProduct/gst-details-advance', body, authToken);

export const VerifyPanUdyamMSMEStatus = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/pan-udyam-msme-status',
    body,
    authToken,
  );

export const VerifyCorporateGstInDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/coporate-gstin', body, authToken);

export const VerifyCreditReport = (body, authToken) =>
  CombineApi.productionPost('apiProduct/credit-report', body, authToken);

export const VerifyCreditReportPdf = (body, authToken) =>
  CombineApi.productionPost('apiProduct/credit-report-pdf', body, authToken);

export const VerifyCreditReportV2 = (body, authToken) =>
  CombineApi.productionPost('apiProduct/credit-report-v2', body, authToken);

export const VerifyDirectPhone = (body, authToken) =>
  CombineApi.productionPost('apiProduct/director-phone', body, authToken);

export const VerifyEcourtsSearchDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/ecourt-cnr', body, authToken);

export const VerifyElectricityBillDetails = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/electricity-bill-details',
    body,
    authToken,
  );

export const VerifyEmploymentHistoryUrn = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/employment-history-uan',
    body,
    authToken,
  );

export const VerifyEmploymentHistorAdvance = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/employment-history-advance',
    body,
    authToken,
  );

export const VerifyFastagRc = (body, authToken) =>
  CombineApi.productionPost('apiProduct/fastag-rc', body, authToken);

export const VerifyFastag = (body, authToken) =>
  CombineApi.productionPost('apiProduct/fastag-details', body, authToken);

export const VerifyFindUPIID = (body, authToken) =>
  CombineApi.productionPost('apiProduct/fetch-upi-details', body, authToken);

export const VerifyMobileTORc = (body, authToken) =>
  CombineApi.productionPost('apiProduct/mobile-to-rc', body, authToken);

export const verifyMobileToUan = (body, authToken) =>
  CombineApi.productionPost('apiProduct/mobile-to-uan', body, authToken);

export const VerifyMobileToBank = (body, authToken) =>
  CombineApi.productionPost('apiProduct/mobile-to-bank', body, authToken);

export const VerifyPanToUAN = (body, authToken) =>
  CombineApi.productionPost('apiProduct/pan-to-uan', body, authToken);

export const VerifyPanAdvance = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/pan-advance-verification',
    body,
    authToken,
  );

export const VerifyPassport = (body, authToken) =>
  CombineApi.productionPost('apiProduct/passport', body, authToken);

export const VerifyRcToMobileNo = (body, authToken) =>
  CombineApi.productionPost('apiProduct/rc-to-mobile', body, authToken);

export const VerifyRationCard = (body, authToken) =>
  CombineApi.productionPost('apiProduct/ration-card', body, authToken);

export const VerifyTan = (body, authToken) =>
  CombineApi.productionPost('apiProduct/tan', body, authToken);

export const VerifyTanCompanySearchDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/tan-company-search', body, authToken);

export const VerifyTelecom = (body, authToken) =>
  CombineApi.productionPost('apiProduct/telecom-verification', body, authToken);

export const TinVerificationDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/tin-verification', body, authToken);

export const VerifyUdyamAadhaarDetails = (body, authToken) =>
  CombineApi.productionPost('apiProduct/udyog-aadhaar', body, authToken);

export const VerifyEchallan = (body, authToken) =>
  CombineApi.productionPost('apiProduct/echallan', body, authToken);

export const VerifyAadharPanLink = (body, authToken) =>
  CombineApi.productionPost('apiProduct/aadhaar-pan-link', body, authToken);

export const CCRVGenerateRequest = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/ccrv-generate-request',
    body,
    authToken,
  );

export const CCRVVerifyRequest = (body, authToken) =>
  CombineApi.productionPost('apiProduct/ccrv-verify-request', body, authToken);

export const employmentCompositeApi = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/verify-employment-uan',
    body,
    authToken,
  );
export const employmentHistoryWageMonthApi = (body, authToken) =>
  CombineApi.productionPost(
    'apiProduct/employment-history-wage-month',
    body,
    authToken,
  );
